import { Modal, ModalBody, ModalFooter, ModalHeader } from "@adeccoux/tag-ds";
import React, { useEffect, useState } from "react";
import { getCall, postCall } from "../../util/resources";

const LanguageSelectorPopupBox = ({
    closePopup,
    assignmentId,
    phrases,
    clangId,
    setSelectedLang,
}) => {
    const [langList, setLangList] = useState([]);
    const [langId, setLangId] = useState([]);
    const [disableDD, setDisableDD] = useState(true);
    const HandelLanguageDD = (e) => {
        setLangId(e.target.value);
        setSelectedLang(e.target.value);
        setDisableDD(false);
    };

    const updateLang = () => {
        try {
            let header2 = {
                "xpert-header-lang": langId,
                "x-xpert-session": assignmentId,
            };
            let data = {};
            //console.log(header2);
            postCall("/rest/tt/updateCandidateLang", data, {
                "x-xpert-session": assignmentId,
                "xpert-header-lang": langId,
            }).then((response) => {
                if (response.status != 200) {
                    window.location.reload();
                } else {
                    window.location.reload();
                }
            });
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        let header = {
            "x-xpert-session": assignmentId,
        };
        getCall("/rest/tt/getCountryLangList", header).then((response) => {
            if (response.status != 200) {
                // console.log("Error");
            } else {
                setLangList(response.data.countryLangList);
            }
        });
    }, []);

    return (
        <Modal
            data-testid="modal-test"
            className=""
            style={{ width: "50%" }}
            open={true}
            onClose={closePopup}
            hasIconClose={true}
            renderAsPortal
        >
            <ModalHeader>
                <h4>{phrases?.["114"]}</h4>
            </ModalHeader>
            <ModalBody>
                <div>
                    <span> {phrases?.["20023603"]}</span>
                    <div style={{ paddingTop: "20px" }}>
                        <h5>
                            <label
                                className="caption text_uppercase"
                                htmlFor="LanguageList"
                            >
                                {phrases?.["13164"]}
                                <select
                                    className=""
                                    id="LanguageList"
                                    name="LanguageList"
                                    placeholder="Language"
                                    style={{ width: "auto" }}
                                    onChange={HandelLanguageDD}
                                >
                                    {langList.map((data, idxl) => (
                                        <option
                                            key={idxl}
                                            label={data.optionText}
                                            value={data.optionValue}
                                            selected={
                                                data.optionValue == clangId
                                            }
                                        >
                                            {data.optionText}
                                        </option>
                                    ))}
                                    ;
                                </select>
                            </label>
                        </h5>
                    </div>
                    <div style={{ float: "right" }}>
                        <button
                            className="button-primary text_uppercase"
                            disabled={disableDD}
                            onClick={updateLang}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter className="flex justify-content_start">
                <div></div>
            </ModalFooter>
        </Modal>
    );
};

export default LanguageSelectorPopupBox;
